import { useEffect, useState } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-8 right-8 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-orange-500 text-white hover:bg-orange-600 transition-all duration-300 shadow-lg cursor-pointer"
      aria-label="回到顶部"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}